import { useTranslation } from "@i18n";
import { convertDate } from "../../services/luxonHelper";

function CustomFields({ customMetaData, dueDate }: any) {
  const { t } = useTranslation();
  const customFields = customMetaData?.map((customField: any) => {
    const data = { ...customField };
    if (customField.type === "DATE") {
      data.value = convertDate(Number(data.value), "dateForText");
    }
    return data;
  });

  return (
    <div className="my-2 flex w-full flex-col items-start gap-4 text-xs text-[var(--text-light)]">
      {dueDate && (
        <div className="flex items-center justify-start gap-3 text-xs">
          <span className="truncate text-[var(--text-light)]">{t("Due Date")}</span>
          <span className="flex items-center gap-2.5 rounded bg-[var(--surface-gradient-color2)] px-2 py-0.5 text-xs font-semibold text-[var(--primary-text)]">
            <span>{convertDate(Number(dueDate), "dateForText")}</span>
          </span>
        </div>
      )}
      {customFields?.map((customField: any) => (
        <div key={customField.title} className="flex items-center justify-start gap-3 text-xs">
          <span className="truncate text-[var(--text-light)]">{customField.title}</span>
          <span className="flex items-center gap-2.5 rounded bg-[var(--surface-gradient-color2)] px-2 py-0.5 text-xs font-semibold text-[var(--primary-text)]">
            <span>{customField.value}</span>
          </span>
        </div>
      ))}
    </div>
  );
}

export default CustomFields;
